import React from "react";
import { Badge } from "../components/ui/badge";

export default function AiScoreBadge({ score, testId = "ai-score-badge" }) {
  const total = typeof score === "object" && score !== null ? score.total : Number(score || 0);
  let className = "bg-rose-50 text-rose-700 border-rose-200";
  let label = "Weak";
  if (total >= 75) {
    className = "bg-emerald-50 text-emerald-700 border-emerald-200";
    label = "Strong";
  } else if (total >= 50) {
    className = "bg-amber-50 text-amber-700 border-amber-200";
    label = "Moderate";
  }
  return (
    <Badge
      variant="outline"
      className={`${className} font-medium tabular-nums px-2.5 py-0.5`}
      data-testid={testId}
    >
      {total} · {label}
    </Badge>
  );
}
